import React from "react";
import './Header3.css';
import picture6 from './source/picture6.png'
import {Link} from "react-router-dom"
import BackgroundChanger from './BackgroundChanger';


function Header3() {

  return (
    <div className="header3">
      <BackgroundChanger />
      <div className="header3-box1">
        <div className="header3-box2">
          <div className="header3-box2">
            <div className="header3-box3">
              <div className="header3-box4">
              <img className="header3-box4-picture6" src={picture6} alt="picture6"/>
              </div>
              <div className="header3-box5">
              Sádrokartony
               </div>
               <div className="header3-box8">
              
               </div>
               <div className="header3-box9">
              ŽAJGLA
               </div>
            </div>
            <div className="header3-box6">
            Montáže sádrokartonu, půdní vestavby nebo podlahy... již 5 let pro vás zajišťujeme   
            </div>
            <div className="header3-box7">
              <div className="header3-box10">
              <Link to="/PageKontakt">Kontakt</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header3;
